import React from 'react'
import { PlaceInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import copy from '../../../../../assets/images/icons/copy.svg'

type Props = {
  startEdit: (el: PlaceInterface) => void
  startDuplicate: (el: PlaceInterface) => void
  el: PlaceInterface
  showDetails: (el: PlaceInterface) => void
}

export const ListItem = ({ startEdit, startDuplicate, el, showDetails }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description || '', 100)}</div>
          {el.placeNumber && <div className={classes.placeNumber}>№ {el.placeNumber}</div>}
        </div>
        <div className={classes.settings}>
          <div className={el.isActive ? classes.settingsItem : classes.settingsItemInActive}>
            {el.isActive ? 'Активно' : 'Не активно'}
          </div>
        </div>
      </div>
      <div className={classes.buttons}>
        <IconButton
          display
          onClick={() => {
            showDetails(el)
          }}
          icon={search}
          alt="Детали"
          small
        />
        <IconButton
          display
          onClick={() => {
            startDuplicate(el)
          }}
          icon={copy}
          alt="Копировать"
          small
        />
        <IconButton
          display
          onClick={() => {
            startEdit(el)
          }}
          icon={edit}
          alt="Изменить"
          small
        />
      </div>
    </div>
  )
}